module.exports = __webpack_public_path__ + "app/bento-components/video-list/media/passport.svg?7a73c93ba4fd5c3d5b5bfa98eacf7d22";